import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { categories } from "../../assets/categories";
import { Subscription } from 'rxjs/Subscription';
import { FilterService } from "../filter/filter.service";
import { Filter } from "../filter/filter";

@Component({
  selector: 'app-article-filter',
  templateUrl: './article-filter.component.html',
  styleUrls: ['./article-filter.component.css']
})
export class ArticleFilterComponent implements OnInit {

  public mainCats:Array<string>;
  public filter:Filter;
  public subscription:Subscription;

  constructor(private filterService:FilterService) {
  }

  ngOnInit() {
    this.mainCats = categories.main;
    this.subscription = this.filterService.filter$.subscribe(filter => this.filter = filter);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/article-filter/article-filter.component.ts